import React, { useState } from 'react';
import './Testimony.css';
import CarouselItem from './CarouselItem';
import { images } from '../../../assets';

function Testimony() {
    const [activeIndex, setActiveIndex] = useState(0);

    const data = [
        {
          id: 1,
          name: "Sanket Chaudhari",
          description: "Absolutely phenomenal !!! Great idea to become fit and healthy and with it also contributing our bit to varied causes !! Truly loved the concept !!",
          img: images.schaudhari,
    
        },
        {
          id: 2,
          name: "Haarika Machani",
          description: "It's for a good cause, everytime I take a step I feel proud and rejuvinated that I am walking for a cause. I loved it!",
          img: images.haarika,
          
        },
        {
          id: 3,
          name: "Manoj Agarwal",
          description: "This is a good app.. this helps not only to track fitness and also helps society.. great job Impact team!",
          img:images.manoj,
          
        },
        {
          id: 4,
          name: "Aashi Jain",
          description: "An app which motivates me to walk. The concept of streaks and badges is awesome",
          img: images.aashi,
          
        }
      ];

    const goToPrevSlide = () => {
        setActiveIndex(activeIndex === 0 ? data.length - 1 : activeIndex - 1);
    };

    const goToNextSlide = () => {
        setActiveIndex(activeIndex === data.length - 1 ? 0 : activeIndex + 1);
    };

    return (
        <div className='testimony'>
            <div className='testimonycontent'>
                <div className='profilecontent'>
                    <CarouselItem data={data[activeIndex]} />
                </div>

                <div className='testimonybutton'>
                    <button className='left' onClick={goToPrevSlide}>
                        <img src={images.leftArrow} alt='Left Arrow' />
                    </button>
                    <button className='right' onClick={goToNextSlide}>
                        <img src={images.rightArrow} alt='Right Arrow' />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Testimony;
